// An-Nur Studio theme scripts
(function(){
  // Mobile nav
  var t = document.querySelector('.mobile-toggle');
  var n = document.querySelector('.header__nav');
  if(t && n){ t.addEventListener('click', function(){ n.classList.toggle('is-open'); }); }

  // Fade in on scroll
  if('IntersectionObserver' in window){
    var io = new IntersectionObserver(function(entries){
      entries.forEach(function(e){ if(e.isIntersecting){ e.target.classList.add('is-visible'); io.unobserve(e.target);} });
    },{threshold:.12});
    document.querySelectorAll('.fade-in').forEach(function(el){ io.observe(el); });
  }

  // Product gallery
  document.querySelectorAll('[data-gallery]').forEach(function(g){
    var main = g.querySelector('[data-gallery-main]');
    g.querySelectorAll('[data-gallery-thumb]').forEach(function(btn){
      btn.addEventListener('click', function(){
        var src = btn.getAttribute('data-src');
        if(main && src){ main.setAttribute('src', src); }
        g.querySelectorAll('[data-gallery-thumb]').forEach(function(b){ b.classList.remove('is-active'); });
        btn.classList.add('is-active');
      });
    });
  });

  // Quantity buttons
  document.querySelectorAll('[data-qty]').forEach(function(q){
    var input = q.querySelector('input');
    q.querySelector('[data-qty-minus]').addEventListener('click', function(){
      var v = Math.max(1, (parseInt(input.value,10)||1)-1); input.value = v;
    });
    q.querySelector('[data-qty-plus]').addEventListener('click', function(){
      var v = (parseInt(input.value,10)||1)+1; input.value = v;
    });
  });
})();